import React, { useState, useEffect } from "react";

const Contact = ({ data, onSubmit, onCancel }) => {
  
 const [address, setAddress] = useState(data?.address || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setAddress(data?.address || "");
  }, [data]);

  const handleChange = (e) => {
    setAddress(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!address.trim()) {
      setError("Address is required.");
      return;
    }

    setError("");
    onSubmit({ address });
  };

  return (
    <div>
      <h3>{data?.address ? "Edit Address" : "Create Address"}</h3>
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="form-group">
          <label>Address</label>
          <input
            type="text"
            className="form-control"
            value={address}
            onChange={handleChange}
            placeholder="Enter address"
          />
          {error && <small className="text-danger">{error}</small>}
        </div>

        <div className="mt-3">
          <button type="submit" className="btn btn-success mr-2">
            Save
          </button>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Contact;
